import React, { Component, PropTypes } from 'react'
import URLSearchParams from 'url-search-params'

import FileUpload from './file_upload'

class MultipleFileUpload extends Component {
    static propTypes = {
        appendValue: PropTypes.func.isRequired,
        data: PropTypes.object,
        error: PropTypes.array,
        errorAction: PropTypes.func.isRequired,
        fileNameSuffix: PropTypes.object,
        helpText: PropTypes.node,
        multiple: PropTypes.bool,
        name: PropTypes.string.isRequired,
        removeValue: PropTypes.func,
        uploadAction: PropTypes.func.isRequired,
        value: PropTypes.array,
    }

    static defaultProps = {
        data: {},
        error: [],
        helpText: null,
        multiple: false,
        value: [],
    }

    appendValue = (data) => {
        // tell the composing component to add this file to its internal structure
        this.props.appendValue(data[this.props.name])
    }

    removeItem = (id) => {
        this.props.removeValue(id)
    }

    getFileURL(file) {
        // If we haven't been passed any GET parameters to add to the URL just return it as-is.
        if (! this.props.fileNameSuffix) {
            return file
        }

        // Otherwise, add each one to whatever URL we already have...
        const url = new URL(file)
        const searchParams = new URLSearchParams(url.search)

        for (const [ key, value ] of Object.entries(this.props.fileNameSuffix)) {
            searchParams.set(key, value)
        }

        url.search = searchParams.toString()

        return url.href
    }

    render() {
        let existingFiles = null

        if (this.props.value && this.props.value.length) {
            existingFiles = (
                <ul className="list--unstyled">
                    {
                        this.props.value.map((item, index) => (
                            <li key={ index }>
                                <a href={ this.getFileURL(item.file) } target="_blank">
                                    { item.name }
                                </a>
                                { this.props.removeValue &&
                                    <button
                                        className="btn btn--delete btn--small"
                                        onClick={ this.removeItem.bind(this, item.id) }
                                        style={{ marginLeft: 10 }}
                                    >
                                        <i className="fa fa-times" />
                                    </button>
                                }
                            </li>
                        ))
                    }
                </ul>
            )
        }

        return (
            <div>
                <FileUpload
                    data={ this.props.data }
                    error={ this.props.error }
                    errorAction={ this.props.errorAction }
                    helpText={ this.props.helpText }
                    multiple={ this.props.multiple }
                    name={ this.props.name }
                    updateValue={ this.appendValue }
                    uploadAction={ this.props.uploadAction }
                />

                { existingFiles }
            </div>
        )
    }
}

export default MultipleFileUpload



// WEBPACK FOOTER //
// ./app/components/ui/multiple_file_upload.js